export default __webpack_public_path__ + "static/media/Iot-home-automation.d3327fd0.jpg";